module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row header justify-content-between"
  }, [_c('div', {
    staticClass: "col dates"
  }, [_vm._v(_vm._s(_vm.sponsorshipItem.dates))]), _vm._v(" "), _c('div', {
    staticClass: "col website"
  }, [_vm._v(_vm._s(_vm.sponsorshipItem.siteUrl))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getStaticPath('img/temp/' + _vm.sponsorshipItem.coverUrl)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.sponsorshipItem.name)), _c('br'), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.sponsorshipItem.city) + ", " + _vm._s(_vm.sponsorshipItem.country))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83f32c16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/sidebar/SidebarSponsorshipComponent.vue
// module id = 1458
// module chunks = 1